// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__v0GHY","sectionTitle":"Sidebar_sectionTitle__isAJt"};